import { useRef } from 'react';
import { useFrame, useLoader } from '@react-three/fiber';
import * as THREE from 'three';

export default function DepthImage({ image, depth }) {
    const mesh = useRef();
    const [colorMap, depthMap] = useLoader(THREE.TextureLoader, [image, depth]);

    useFrame(({ mouse }) => {
        if(mesh.current) {
            mesh.current.rotation.y = mouse.x * 0.2;
            mesh.current.rotation.x = -mouse.y * 0.1;
        }
    });

    return (
        <mesh ref={mesh}>
            <planeGeometry args={[4, 3, 64, 64]} />
            <meshStandardMaterial
                map={colorMap}
                displacementMap={depthMap}
                displacementScale={0.25}
                roughness={0.3}
                metalness={0.1}
            />
        </mesh>
    );
}